const headers = {
    'x-api-key':process.env.REACT_APP_API_KEY,
    'Content-Type':'application/json'
}

export default headers;